// extracted by mini-css-extract-plugin
export var container = "contact-module--container--cKQWz";
export var row = "contact-module--row--1dJH6";
export var content = "contact-module--content--VI3Cq";
export var pemberitahuan = "contact-module--pemberitahuan--2u6Xq";
export var text = "contact-module--text--2l5RC";
export var title = "contact-module--title--2Yro4";
export var info = "contact-module--info--E7pgk";
export var socialMedia = "contact-module--socialMedia--2LjDg";
export var form = "contact-module--form--ddlf1";
export var formGroup = "contact-module--formGroup--332ka";